import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { clsx } from 'clsx';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un correo con el enlace de descarga. Acceso en menos de 5 minutos, desde cualquier dispositivo.'
  }, {
    q: '¿Sirve si nunca vendí nada en mi vida?',
    a: 'Sí, y es exactamente para quien nunca vendió. El Tomo 1 empieza desde la mentalidad y el Tomo 5 te lleva a tu primera venta paso a paso. No se asume ningún conocimiento previo.'
  }, {
    q: '¿Cuánta plata necesito para arrancar?',
    a: 'El sistema está diseñado para capital inicial mínimo. El Tomo 3 explica cómo empezar con una inversión pequeña en mercadería y el Tomo 5 tiene un plan para hacer tu primera venta antes de gastar en stock grande. La calculadora del Tomo 1 te ayuda a definir tu objetivo según tu presupuesto real.'
  }, {
    q: '¿Los 3 bonos están incluidos en las dos ofertas?',
    a: 'Sí. El directorio de proveedores, el directorio de ferias y la guía de campo de zonas mayoristas están incluidos tanto en el Kit ($19.990) como en el Megapack ($27.990). La diferencia entre los dos son los Tomos 7 y 8.'
  }, {
    q: '¿Funciona si vivo en el interior del país?',
    a: 'Sí. El directorio de proveedores incluye CABA, GBA, Córdoba, Rosario, Santa Fe, Mendoza, Tucumán y más. El directorio de ferias también cubre todo el territorio nacional. Y la sección de proveedores online del Bono 1 es válida desde cualquier punto del país.'
  }, {
    q: '¿Qué diferencia tiene con buscar en YouTube?',
    a: 'YouTube da información fragmentada, de otros países, sin contexto argentino, sin proveedores locales verificados, sin ferias, sin Mercado Pago. El sistema está armado específicamente para Argentina: precios en pesos, proveedores que podés ir a ver hoy, ferias donde podés estar la semana que viene y guiones en el español que usamos acá.'
  }, {
    q: '¿Por qué elegir el Megapack y no solo el Kit?',
    a: 'El Kit te lleva a tu primera venta. El Megapack te da el sistema completo para que esa primera venta se convierta en un negocio: con marca en redes, clientes que vuelven solos y un sistema de referidos que trabaja sin que estés buscando clientes nuevos todo el tiempo. La diferencia es $8.000 — lo que sale una pulsera de plata 925 en cualquier mayorista.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total. Si no es lo que esperabas, mandás un mensaje y te devolvemos el 100% sin preguntas, sin formularios y sin drama. La tasa de devoluciones es menor al 1%.'
  }, {
    q: '¿Los precios del sistema se actualizan con la inflación?',
    a: 'El sistema enseña fórmulas y metodología, no precios fijos. La fórmula del Tomo 4 funciona con cualquier valor de costo porque se basa en el multiplicador, no en un número estático. Así no queda desactualizado aunque cambie el mercado.'
  }];
  return <section className="py-12 sm:py-20" data-id="element-107">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-108">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-109">
          Dudas comunes
        </div>
        <h2 className="mb-8 sm:mb-9 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-110">
          Preguntas frecuentes
        </h2>

        <div className="flex flex-col gap-0.5" data-id="element-111">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border-b border-border" data-id="element-112">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[15px] font-medium text-white" aria-expanded={isOpen} data-id="element-113">
                  {faq.q}
                  <Plus className={clsx('h-5 w-5 shrink-0 text-gold transition-transform duration-250', isOpen && 'rotate-45')} data-id="element-114" />
                </button>
                <AnimatePresence initial={false} data-id="element-115">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-116">
                      <div className="pb-5 text-[14px] leading-[1.7] text-text" data-id="element-117">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}